import React from "react";
import Sidebar, { useSidebarState } from "./Sidebar";

export default function AppLayout({ children, header }) {
  const [collapsed, setCollapsed] = useSidebarState();
  return (
    <div className="min-h-screen bg-slate-50" data-testid="app-layout">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <main
        className={`min-h-screen min-w-0 transition-[margin] duration-150 ease-out ${
          collapsed ? "md:ml-[68px]" : "md:ml-[240px]"
        }`}
      >
        {header && (
          <div className="border-b border-slate-200 bg-white sticky top-0 z-20">
            <div className="px-6 md:px-8 py-4">{header}</div>
          </div>
        )}
        <div className="p-6 md:p-8">{children}</div>
      </main>
    </div>
  );
}
